import { Items } from 'src/app/core/models/common/items.model';
import {
  GetOutboundGLEResponse,
  OutboundScan,
} from 'src/app/core/models/position-operations/outbound-gle.model';

export enum ColumnIds {
  EQUIPMENT_NUMBER = 'equipmentNumber',
  EQUIPMENT_TYPE = 'equipmentType',
  SEAL_NUMBER = 'sealNumber',
  CREATE_SORT_DATE = 'createSortDate',
  SORT = 'sort',
  LOAD_NAME = 'loadName',
  LOAD_CHART = 'loadChart',
  MOVEMENT = 'movement',
  PARENT_ULD = 'parentUld',
  TYPE = 'type',
  ACTION = 'action',
}

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
  NEW_ULD: $localize`New ULD`,
};

export const ColumnText = {
  EQUIPMENT_NUMBER: $localize`Equipment Number`,
  EQUIPMENT_TYPE: $localize`Equipment Type`,
  SEAL_NUMBER: $localize`Seal Number`,
  CREATE_SORT_DATE: $localize`Create/Sort Date`,
  SORT: $localize`Sort`,
  LOAD_NAME: $localize`Load Name`,
  LOAD_CHART: $localize`Load Chart`,
  MOVEMENT: $localize`Movement`,
  PARENT_ULD: $localize`Parent ULD`,
  TYPE: $localize`Type`,
  ACTION: $localize`Action`.toUpperCase(),
};

export const EXCEL_FILE_NAME = $localize`outbound-scan-data`;

export const SORT_OPTIONS: Items[] = [
  { id: 'S', label: 'Sunrise - S', selected: true },
  { id: 'M', label: 'Morning - M', selected: true },
  { id: 'D', label: 'Day - D', selected: true },
  { id: 'T', label: 'Twilight - T', selected: true },
  { id: 'N', label: 'Night - N', selected: true },
  { id: 'P', label: 'Preload - P', selected: true },
  { id: 'L', label: 'Local - L', selected: true },
  { id: 'A', label: 'Afternoon - A', selected: true },
];

export const EQUIPMENT_TYPE_OPTIONS: Items[] = [
  { id: 'Container - C', selected: true },
  { id: 'Trailer - T', selected: true },
  { id: 'Belly - BE', selected: true },
  { id: 'Package Car - PC', selected: true },
  { id: 'Cage - CG', selected: true },
  { id: 'Bag - B', selected: true },
];

export const TYPE_OPTIONS: Items[] = [
  { id: 'UP', selected: true },
  { id: 'CO', selected: true },
];

export enum SORTS_TYPES {
  SUNRISE = 'Sunrise - S',
  MORNING = 'Morning - M',
  DAY = 'Day - D',
  TWILIGHT = 'Twilight - T',
  NIGHT = 'Night - N',
  PRELOAD = 'Preload - P',
  LOCAL = 'Local - L',
  AFTERNOON = 'Afternoon - A',
}
export enum EQUIPMENT_TYPES {
  CONTAINER = 'Container - C',
  TRAILER = 'Trailer - T',
  BELLY = 'Belly - BE',
  PACKAGE_CAR = 'Package Car - PC',
  CAGE = 'Cage - CG',
  BAG = 'Bag - B',
}

export const MOCK_TABLE_CONSTS: OutboundScan[] = [
  {
    id: 123,
    equipmentNumber: 'B7040S92WQ0',
    equipmentType: 'Container - C',
    sealNumber: 'SealNum',
    createSortDate: 'May 10, 2023',
    sort: 'Sunrise - S',
    loadName: 'GB 1719 T GNDD',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST192920',
    type: 'UP',
    positionBelt: 'TEST-INTERNATIONAL',
    positionBay: '00001',
    sealControl: '123456789',
  },
  {
    id: 1234,
    equipmentNumber: 'B7040S92WQ0',
    equipmentType: 'Belly - BE',
    sealNumber: 'SealNum',
    createSortDate: 'May 10, 2023',
    sort: 'Night - N',
    loadName: 'US 3030 P GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: '-',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '00002',
  },
  {
    id: 12345,
    equipmentNumber: 'B7952R92YS0',
    equipmentType: 'Trailer - T',
    sealNumber: 'SealNum',
    createSortDate: 'May 2, 2023',
    sort: 'Morning - M',
    loadName: 'US 1719 T GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST192920',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '00003',
  },
  {
    id: 12345,
    equipmentNumber: 'UPSTEST1',
    equipmentType: 'Container - C',
    sealNumber: 'SealNum',
    createSortDate: 'June 5, 2023',
    sort: 'Twilight - T',
    loadName: 'US 4049 N 1DA',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST180882',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '00004',
  },
  {
    id: 12346,
    equipmentNumber: 'JW0193NIASD0',
    equipmentType: 'Package Car - PC',
    sealNumber: 'SealNum',
    createSortDate: 'June 8, 2023',
    sort: 'Preload - P',
    loadName: 'D_GLE_US 1719 GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'RETAIN',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '00005',
  },
  {
    id: 12347,
    equipmentNumber: 'TEST0829202',
    equipmentType: 'Package Car - PC',
    sealNumber: 'SealNum',
    createSortDate: 'July 9, 2023',
    sort: 'Local - L',
    loadName: 'CA 4779 P GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'NONZ9210',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '00006',
  },
  {
    id: 123478,
    equipmentNumber: 'JW3930QWQWO',
    equipmentType: 'Bag - B',
    sealNumber: 'SealNum',
    createSortDate: 'September 10, 2023',
    sort: 'Local - L',
    loadName: 'US 3030 P GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST192920',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '00007',
  },
  {
    id: 1234464,
    equipmentNumber: 'B9049S92QM9',
    equipmentType: 'Bag - B',
    sealNumber: 'SealNum',
    createSortDate: 'March 9, 2023',
    sort: 'Afternoon - A',
    loadName: 'CA 4779 P GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'NONZ9210',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '00008',
  },
  {
    id: 1234454,
    equipmentNumber: 'B7049S92WW0',
    equipmentType: 'Belly - BE',
    sealNumber: 'SealNum',
    createSortDate: 'June 6, 2023',
    sort: 'Afternoon - A',
    loadName: 'D_GLE_US 1719 GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'RETAIN',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '00009',
  },
  {
    id: 1234454,
    equipmentNumber: 'PO0292NQWQW4',
    equipmentType: 'Cage - CG',
    sealNumber: 'SealNum',
    createSortDate: 'August 5, 2023',
    sort: 'Sunrise - S',
    loadName: 'US 4049 N 1DA',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST192920',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '000010',
  },
  {
    id: 12356544,
    equipmentNumber: 'JW0193NIASD0',
    equipmentType: 'Cage - CG',
    sealNumber: 'SealNum',
    createSortDate: 'May 3, 2023',
    sort: 'Morning - M',
    loadName: 'US 1719 T GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST180882',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '000011',
  },
  {
    id: 123454234,
    equipmentNumber: 'JW3930QWQWO',
    equipmentType: 'Package Car - PC',
    sealNumber: 'SealNum',
    createSortDate: 'July 2, 2023',
    sort: 'Day - D',
    loadName: 'US 4049 N 1DA',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'UPST180882',
    type: 'CO',
    positionBelt: 'DOMESTIC',
    positionBay: '00012',
  },
  {
    id: 123447787,
    equipmentNumber: 'B7049S92WW0',
    equipmentType: 'Trailer - T',
    sealNumber: 'SealNum',
    createSortDate: 'May 5, 2023',
    sort: 'Night - N',
    loadName: 'CA 4779 P GND',
    loadChart: 'LoadChart',
    movement: 'Movement',
    parentUld: 'NONZ9210',
    type: 'UP',
    positionBelt: 'DOMESTIC',
    positionBay: '000013',
  },
];

export const MOCK_GET_OUTBOUND_GLE_RESPONSE: GetOutboundGLEResponse = {
  code: 200,
  status: 'success',
  deviceStatus: 'Active',
  response: {
    ulos: [
      {
        id: 1560024616,
        sortDate: '2024-12-18',
        uldCount: 0,
        losseCount: 1,
        parentUld: 'UPST1001',
        loadKey: {
          discriminator: 'DOMESTIC',
          origin: {
            country: 'CA',
            slic: '1375',
            portCode: '1375',
            sortCode: '08',
            qualifier: '1',
          },
          destination: {
            country: 'CA',
            slic: '1549',
            portCode: '1549',
            sortCode: '04',
          },
          processing: {
            country: 'CA',
            slic: '1375',
            portCode: '1375',
            sortCode: '08',
          },
          uld: {
            type: '02',
            number: 'TEST212',
            seal: '123',
          },
          service: '001',
          packageLocationRole: '12',
          disposition: '00',
          scanType: '03',
          loadChart: 'SLEMONPARK',
          movement: {
            mvmtNum: '1375ENHC',
            mvmtType: 'G',
          },
          dataCapture: false,
          usps: false,
          carryOver: false,
          bulk: false,
          loadType: 'LD',
          loadDescription: '',
          loadName: 'test',
          flowType: 'LOCAL',
          position: {
            belt: 'QATEST',
            bay: '0001',
            smallSort: false,
            location: 'rerte',
          },
          upsPremier: false,
          seal: '',
        },
        userName: '123',
        sealnumber: '123',
        origsort: '123',
        loadchart: '132',
        mvmtnum: '123',
      },
    ],
  },
};

// export const MOCK_GET_GLE_LOADS_RESPONSE: GetGleLoadsResponse = {
//   code: 200,
//   status: 'success',
//   deviceStatus: 'Active',
//   response: {
//     loadKeys: [
//       {
//         id: 110906,
//         changeId: 13177321359659,
//         planType: {
//           mnemonic: 'D',
//           priority: 0,
//         },
//         name: 'GLE_SLEMONPARK',
//         active: true,
//         effective: '2018-04-09',
//         expires: '2040-12-31',
//         daysOfTheWeek: {
//           sunday: true,
//           monday: true,
//           tuesday: true,
//           wednesday: true,
//           thursday: true,
//           friday: true,
//           saturday: true,
//         },
//         loadKey: {
//           descrim: 'INTERNATIONAL',
//           origin: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           destination: {
//             country: 'CA',
//             slic: '1549',
//             portCode: '1549',
//             sortCode: 'T',
//             qualifier: '1',
//           },
//           processing: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           uld: {},
//           service: '001',
//           packageLocationRole: '12',
//           disposition: 'X3',
//           scanType: '01',
//           loadChart: 'SLEMONPARK',
//           movement: {
//             mvmtNum: '1375ENHC',
//             mvmtType: 'G',
//           },
//           dataCapture: true,
//           usps: false,
//           carryOver: false,
//           bulk: false,
//           loadType: 'LD',
//           loadDescription: 'SEC SCR X3',
//           flowType: 'OPSYS',
//           loadName: 'GLE_SLEMONPARK',
//           position: {
//             belt: 'QATEST',
//             bay: '0001',
//             smallSort: false,
//           },
//           upsPremier: false,
//         },
//         allowedServices: [
//           '001',
//           '102',
//           '101',
//           '002',
//           '103',
//           '012',
//           '014',
//           '004',
//         ],
//         alternateLoadChart: [
//           {
//             loadChart: 'exampleChart',
//             daysOfTheWeek: {
//               sunday: true,
//               monday: false,
//               tuesday: true,
//               wednesday: false,
//               thursday: true,
//               friday: false,
//               saturday: true,
//             },
//           },
//         ],
//         dataCaptReq: false,
//       },
//       {
//         id: 123485,
//         changeId: 13177321359659,
//         planType: {
//           mnemonic: 'D',
//           priority: 0,
//         },
//         name: 'GLE_SLEMONPARK',
//         active: true,
//         effective: '2019-06-19',
//         expires: '2040-12-31',
//         daysOfTheWeek: {
//           sunday: true,
//           monday: true,
//           tuesday: true,
//           wednesday: true,
//           thursday: true,
//           friday: true,
//           saturday: true,
//         },
//         loadKey: {
//           descrim: 'INTERNATIONAL',
//           origin: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           destination: {
//             country: 'CA',
//             slic: '1549',
//             portCode: '1549',
//             sortCode: 'T',
//             qualifier: '1',
//           },
//           processing: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           uld: {},
//           service: '001',
//           packageLocationRole: '12',
//           disposition: 'X2',
//           scanType: '01',
//           loadChart: 'SLEMONPARK',
//           movement: {
//             mvmtNum: '1375ENHC',
//             mvmtType: 'G',
//           },
//           dataCapture: true,
//           usps: false,
//           carryOver: false,
//           bulk: false,
//           loadType: 'LD',
//           loadDescription: 'SEC SC X2- DOM Inter',
//           flowType: 'OPSYS',
//           loadName: 'GLE_SLEMONPARK',
//           position: {
//             belt: 'QATEST',
//             bay: '0001',
//             smallSort: false,
//           },
//           upsPremier: false,
//         },
//         allowedServices: [
//           '001',
//           '102',
//           '101',
//           '002',
//           '103',
//           '012',
//           '014',
//           '004',
//         ],
//         alternateLoadChart: [
//           {
//             loadChart: 'exampleChart',
//             daysOfTheWeek: {
//               sunday: true,
//               monday: false,
//               tuesday: true,
//               wednesday: false,
//               thursday: true,
//               friday: false,
//               saturday: true,
//             },
//           },
//         ],
//         dataCaptReq: false,
//       },
//       {
//         id: 53497,
//         changeId: 13177321359659,
//         planType: {
//           mnemonic: 'D',
//           priority: 0,
//         },
//         name: 'GLE_CA 1549 T 1DA',
//         active: true,
//         effective: '2014-03-31',
//         expires: '2040-12-31',
//         daysOfTheWeek: {
//           sunday: true,
//           monday: true,
//           tuesday: true,
//           wednesday: true,
//           thursday: true,
//           friday: true,
//           saturday: true,
//         },
//         loadKey: {
//           descrim: 'DOMESTIC',
//           origin: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           destination: {
//             country: 'CA',
//             slic: '1549',
//             portCode: '1549',
//             sortCode: 'T',
//             qualifier: '1',
//           },
//           processing: {
//             country: 'CA',
//             slic: '1375',
//             portCode: '1375',
//             sortCode: 'A',
//             qualifier: '1',
//           },
//           uld: {},
//           service: '001',
//           packageLocationRole: '12',
//           disposition: '00',
//           scanType: '03',
//           loadChart: 'SLEMONPARK',
//           dataCapture: false,
//           usps: false,
//           carryOver: false,
//           bulk: false,
//           loadType: 'LD',
//           flowType: 'LOCAL',
//           loadName: 'GLE_CA 1549 T 1DA',
//           position: {
//             belt: 'QATEST',
//             bay: '0001',
//             smallSort: false,
//           },
//           upsPremier: false,
//         },
//         allowedServices: [
//           '001',
//           '102',
//           '101',
//           '002',
//           '103',
//           '012',
//           '014',
//           '004',
//         ],
//         alternateLoadChart: [
//           {
//             loadChart: 'exampleChart',
//             daysOfTheWeek: {
//               sunday: true,
//               monday: false,
//               tuesday: true,
//               wednesday: false,
//               thursday: true,
//               friday: false,
//               saturday: true,
//             },
//           },
//         ],
//         dataCaptReq: false,
//       },
//     ],
//   },
// };
